import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForward = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "16px",
	viewBox: "0 0 24 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "noun_Reply_258094" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "GC-Chat-Design-Next-Steps",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "weiterleiten",
				transform: "translate(-282.000000, -64.000000)",
				fill: "#7A7A7A",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-23",
					transform: "translate(168.000000, 61.000000)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "noun_Reply_258094",
						transform: "translate(114.000000, 3.000000)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M0.154112126,14.463018 C3.99506051,3.89289646 14.7710546,4.05468404 14.7710546,4.05468404 C14.7710546,4.05468404 14.6910348,3.08395859 14.6910348,1.43911824 C14.6110151,-0.259651298 15.3045196,-0.340545085 16.4781428,0.603215769 C19.252161,2.89520642 24,7.39829392 24,7.39829392 C24,7.39829392 19.5188936,11.9013814 16.931588,14.4899826 C15.6779452,15.730354 14.8244011,16.1617876 14.7710546,13.8697969 C14.6643616,12.197992 14.7710546,10.795833 14.7710546,10.795833 C14.7710546,10.795833 8.15608792,9.69028457 3.48826871,13.2496112 C0.767596938,15.0562391 0.3941714,15.7842832 0.154112126,16 C0.154112126,16 -0.192640158,15.7842832 0.154112126,14.463018 Z",
							id: "Path"
						})
					})
				})
			})
		})
	]
});
export default SvgForward;
